import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useCustomNavigate from "./../hooks/useCustomNavigate";
import usePermission from "./../hooks/usePermission";
import axios from "./../services/http";
import { NumericFormat } from 'react-number-format';
import DraggerFileComponent from "./../modules/Shared/components/DraggerFileComponent";
import { Breadcrumb, Layout, Form, Input, Button, Select, Typography, message, Card } from 'antd';
const { Content } = Layout;

const { TextArea } = Input;

function AnadirMontoForm({ goBack }) {

  //Permisos
  const canChooseRelat = usePermission({ permission: "elegir_relacion" });

  const location = useLocation();
  const { from } = location.state;
  const navigate = useCustomNavigate();

  const [obra, setObra] = useState({nombre_obra: ''});
  const [form] = Form.useForm();
  const [contratistas, setContratistas] = useState([]);
  const [controlesDePago, setControlesDePago] = useState([]);
  const [selectedContratista, setSelectedContratista] = useState();
  const [relacion, setRelacion] = useState('');
  const [partida, setPartida] = useState('');
  const [catTypes, setCatTypes] = useState([]);
  const [catRelaciones, setCatRelaciones] = useState([]);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    setObra(from);

    const fetchContratistas = async () => {
      try {
        const response = await axios.HTTP_GET(`/api/contratistas/${obra.id}`);
        setContratistas(response);
      } catch (error) {
        console.error('Error al cargar los contratistas:', error);
      }
    };

    const fetchRelacion = async () => {
      try {
        const response = await axios.HTTP_GET(`/api/relacion-semanal/${from.id}`);
        setRelacion(response.numeroRelacion);
        let relaciones = [];
        for(let i = 1; i <= response.numeroRelacion; i++) relaciones.push({value:i});
        setCatRelaciones(relaciones);
        form.setFieldsValue({ relacion: response.numeroRelacion });

      } catch (error) {
        console.error('Error al obtener la relación:', error);
      }
    };
    fetchRelacion();

    fetchContratistas();
    fetchControlesDePago();
  }, [obra]);

  useEffect(() => {
    const getBalance = setTimeout(() => {
      ValidateActualBalance();
    }, 800);

    return () => clearTimeout(getBalance)
  }, [balance]);

  const fetchControlesDePago = async (contratistaId) => {
    try {
      const response = await axios.HTTP_GET(`/api/controlesdepago/${obra.id}/${contratistaId}`);
      setControlesDePago(response);
    } catch (error) {
      console.error('Error al cargar los controles de pago:', error);
    }
  };

  const Navigate = (path, params) => {
    navigate(path, params);
  }


  const onFormValuesChange = (changedValues) => {
    if (changedValues.controlPago) {
      const controlSeleccionado = controlesDePago.find((cp) => cp.id === changedValues.controlPago);
      if (controlSeleccionado) {

        if (controlSeleccionado.presupuesto_iva === 100 && controlSeleccionado.presupuesto_no_iva === 0) setCatTypes([{ value: 'FISCAL', label: "Fiscal" }]);
        else if (controlSeleccionado.presupuesto_no_iva === 100 && controlSeleccionado.presupuesto_iva === 0) setCatTypes([{ value: 'NO FISCAL', label: "No Fiscal" }]);
        else setCatTypes([{ value: 'FISCAL', label: "Fiscal" },{ value: 'NO FISCAL', label: "No Fiscal" }]);

        setPartida(controlSeleccionado.partidas || '');
      } else {
        setPartida('');
      }
    }
  };

  const handleContratistaChange = (value) => {
    const contratistaId = value;
    setSelectedContratista(contratistaId);
    form.setFieldsValue({ controlPago: undefined });
    form.setFieldsValue({ partidas: undefined });
    setPartida(null);
    fetchControlesDePago(contratistaId);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      let nuevoGasto = {
        obra_id: obra.id,
        control_pago_id: values.controlPago,
        contabilidad_id: values.controlPago,
        contratista_id: values.contratista,
        partida,
        importe: (typeof values.monto === "string" ? parseFloat(values.monto.replace(/[$, ]/g,'')).toFixed(2) : values.monto),
        observaciones: values.comentarios,
        tipo_monto: values.tipoMonto,
        tipo_de_pago: null,
        relacion: values.relacion,
        files: values.files
      };
      let cps = controlesDePago;
      let controlSeleccionado = {};
      for(let i = 0; i < cps.length; i++) {
        if (cps[i].id === values.controlPago) {
          controlSeleccionado = cps[i];
          break;
        }
      }
      if (controlSeleccionado.sub_cp === 1) nuevoGasto["tipo"] = "SUB_CP";
      else nuevoGasto["tipo"] = "CP";

      // console.log("Nuevo Gasto: x1", values.monto.replace(/[$,]/g,''));
      // let amount = parseFloat(values.monto.replace(/[$, ]/g,'')).toFixed(2);
      // console.log("Nuevo Gasto:", amount);

      const response = await axios.HTTP_POST('/api/v1/relationship/save', nuevoGasto);
      message.success(response.data.message);
      navigate("/home", { state: { from: from } })
    } catch (error) {
      console.error('Error al añadir el gasto:', error);
      message.error('Hubo un error al añadir el gasto');
    }
  };

  const onSuccessUpload = async params => form.setFieldsValue({ "files": [params.response.path] });

  const ValidateActualBalance = async () => {
    try {
      let total = 0;
      const values = await form.validateFields();
      if (typeof balance === "string") total = parseFloat(balance.replace(/[$, ]/g,'')).toFixed(2);
      if (total > 0) {
        const response = await axios.HTTP_GET(`/api/v1/relationship/get-balance/${values.tipoMonto}/${total}/${values.controlPago}`);
        if (response === true) {
          message.warning("El pago no puede sobrepasar del saldo real");
          form.setFieldsValue({ monto: 0 });
        }
      }
    } catch (e) {
      
    }
  }

  return (
    <Layout>
      <Content className="rpimary-container">
        <Breadcrumb 
          className='breadcrumb' 
          items={[
              { title: <a href="/home">Inicio</a> },
              { title: "Ingresar Pago" }
          ]} 
        />
        <Card style={{ margin: 'auto', marginTop: 16, maxWidth: '900px' }}>
          <div>
            <Typography.Title level={3}>Ingresar Pago</Typography.Title>
            <Typography.Title level={4}>Obra: {obra.nombre_obra}</Typography.Title>
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSubmit}
              onValuesChange={onFormValuesChange}
            >
              <Form.Item
                label="Seleccionar Contratista"
                name="contratista"
                rules={[{ required: true, message: 'Por favor selecciona un contratista' }]}
              >
                <Select 
                  placeholder="Selecciona un contratista"
                  value={selectedContratista || undefined}
                  onChange={handleContratistaChange}
                >
                  {contratistas.map((c) => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.nombre_contratista}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              {selectedContratista && (
                <>
                  <Form.Item
                    label="Seleccionar Control de Pagos"
                    name="controlPago"
                    rules={[{ required: true, message: 'Por favor selecciona un control de pagos' }]}
                  >
                    <Select placeholder="Selecciona un control de pagos">
                      {controlesDePago.map((cp) => (
                        <Select.Option key={cp.id} value={cp.id}>
                          {cp.concepto}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Relación"
                    name="relacion"
                    rules= {!canChooseRelat?[]:[{required: true, message: 'Por favor selecciona una relación'}]}
                  >
                    {!canChooseRelat?<Input value={partida} disabled />
                    :<Select value="relacion" options={catRelaciones} />}
                  </Form.Item>

                  {/* <Form.Item label="Partida">
                    <Input value={partida} disabled />
                  </Form.Item> */}

                  <Form.Item
                    label="Tipo"
                    name="tipoMonto"
                    rules={[{ required: true, message: 'Por favor selecciona un tipo' }]}
                  >
                    <Select options={catTypes} />
                  </Form.Item>

                  <Form.Item
                    label="Monto"
                    name="monto"
                    rules={[
                      { required: true, message: 'Por favor ingrese el monto' },
                      // {
                      //   validator: (_, value) =>
                      //     value < 0
                      //       ? Promise.reject(new Error('El monto no puede ser negativo'))
                      //       : Promise.resolve(),
                      // },
                    ]}
                  >
                    {/* <Input type="number" min={0} placeholder="Ingrese el monto" /> */}
                    <NumericFormat 
                        thousandSeparator={true} prefix={'$ '} 
                        customInput={Input}
                        onChange={e => setBalance(e.target.value)}
                      />
                  </Form.Item>
                  <Typography.Text type="secondary">Valor antes de IVA</Typography.Text>
                  {/* <Form.Item
                    label="Tipo de Pago"
                    name="tipoDePago"
                    rules={[{ required: true, message: 'Por favor selecciona un tipo de pago' }]}
                  >
                    <Select placeholder="Selecciona un tipo de pago">
                      <Select.Option value="Material">Material</Select.Option>
                      <Select.Option value="Mano de obra">Mano de obra</Select.Option>
                      <Select.Option value="Subcontrato">Subcontrato</Select.Option>
                      <Select.Option value="Herramienta">Herramienta</Select.Option>
                      <Select.Option value="Equipo">Equipo</Select.Option>
                      <Select.Option value="Indirecto">Indirecto</Select.Option>
                    </Select>
                  </Form.Item> */}
                  {/* {usePermission("elegir_relacion") && (
                    <Form.Item
                      label="Relación"
                      name="relacion"
                      rules={[{ required: true, message: 'Por favor selecciona una relación' }]}
                    >
                      <Select options={[]} />
                    </Form.Item>
                  )} */}
                  <Form.Item label="Comentarios" name="comentarios">
                    <TextArea placeholder="Ingrese sus comentarios" rows={4} />
                  </Form.Item>
                  
                  <Form.Item name="files">
                    <DraggerFileComponent 
                      id="file"  
                      multiple={false}
                      action="/api/v1/payments/upload-documents"
                      token={localStorage.getItem('token') || null}
                      accept=""
                      onSuccessUpload={onSuccessUpload}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Crear Gasto
                    </Button>
                    <Button type="default" onClick={() => navigate("/home", { state: { from: from } } )} style={{ marginLeft: 8 }}>
                      Cancelar
                    </Button>
                  </Form.Item>
                </>
              )}


            </Form>
          </div>
        </Card>
      </Content>
    </Layout>
  );
}

export default AnadirMontoForm;
